import { render, staticRenderFns } from "./MainViewMobile.vue?vue&type=template&id=cbc67804&scoped=true&"
import script from "./MainViewMobile.vue?vue&type=script&lang=js&"
export * from "./MainViewMobile.vue?vue&type=script&lang=js&"
import style0 from "./MainViewMobile.vue?vue&type=style&index=0&id=cbc67804&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc67804",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
